import { createContext, PropsWithChildren, useContext } from "react";

export interface DiagramNodeOption {
    id: string;
    type: string;
    sortOrder?: number;
    label?: string;
    /** Actual flow number based on graph connectivity (0 = orphan/not connected) */
    flowNumber: number;
    /** Flow type from Start node (post, ping, webhook, instant) */
    flowType?: string;
}

interface DiagramNodesContextValue {
    nodeOptions: DiagramNodeOption[];
}

const DiagramNodesContext = createContext<DiagramNodesContextValue | null>(null);

export const DiagramNodesProvider = ({
    children,
    nodeOptions,
}: PropsWithChildren<{ nodeOptions: DiagramNodeOption[] }>) => {
    return <DiagramNodesContext.Provider value={{ nodeOptions }}>{children}</DiagramNodesContext.Provider>;
};

export const useDiagramNodes = () => {
    const context = useContext(DiagramNodesContext);
    if (!context) {
        throw new Error("useDiagramNodes must be used within DiagramNodesProvider");
    }
    return context;
};
